var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarRental = function SvgCarRental(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 14.834c.888 0 1.687.386 2.236 1h7.528c.55-.614 1.348-1 2.236-1 .889 0 1.687.386 2.236 1H22v-3.266l-5.142-.734H3.43L2 12.293v3.54h1.764c.55-.613 1.348-1 2.236-1zm-4 3a2 2 0 01-2-2v-3.541a2 2 0 011.39-1.905l1.578-.506 2.522-4.2a2 2 0 011.494-.958l6.41-.712a2 2 0 012.117 1.356L17 9.834l5.283.755A2 2 0 0124 12.569v3.265a2 2 0 01-2 2h-1a3 3 0 01-6 0H9a3 3 0 01-6 0H2zM13.614 6l-6.41.712L5.33 9.834h9.562L13.614 6zM18 18.834a1 1 0 100-2 1 1 0 000 2zm-12 0a1 1 0 100-2 1 1 0 000 2z"
  })));
};
export default SvgCarRental;